var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83366 13.3334H14.167C16.4682 13.3334 18.3337 15.1988 18.3337 17.5C18.3337 17.9603 17.9606 18.3334 17.5003 18.3334C17.073 18.3334 16.7207 18.0117 16.6726 17.5972L16.6627 17.3531C16.5895 16.0894 15.5776 15.0775 14.3139 15.0043L14.167 15H5.83366C4.45295 15 3.33366 16.1193 3.33366 17.5C3.33366 17.9603 2.96056 18.3334 2.50033 18.3334C2.04009 18.3334 1.66699 17.9603 1.66699 17.5C1.66699 15.2594 3.43558 13.4318 5.65292 13.3372L5.83366 13.3334H14.167H5.83366ZM10.0003 1.66669C12.7617 1.66669 15.0003 3.90526 15.0003 6.66669C15.0003 9.42811 12.7617 11.6667 10.0003 11.6667C7.2389 11.6667 5.00033 9.42811 5.00033 6.66669C5.00033 3.90526 7.2389 1.66669 10.0003 1.66669ZM10.0003 3.33335C8.15938 3.33335 6.66699 4.82574 6.66699 6.66669C6.66699 8.50764 8.15938 10 10.0003 10C11.8413 10 13.3337 8.50764 13.3337 6.66669C13.3337 4.82574 11.8413 3.33335 10.0003 3.33335Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.dfaa153b.svg";
export { ForwardRef as ReactComponent };